import { boot } from 'quasar/wrappers'

export default boot(async ({ router, store }) => {
  await store.dispatch('auth/init')

  router.beforeEach((to, _, next) => {
    if (to.meta.public) {
      next()
      return
    }
    const is402 = to.path === '/402'
    if (store.getters['subscription/blocked'] !== is402) {
      next(is402 ? { name: 'login' } : '/402')
      return
    }
    if (is402) {
      next()
      return
    }
    const is403 = to.path === '/403'
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const { loggedIn, user } = store.state.auth
    const isAdmin = user.Dashboard_Autorizzazione === 1
    if (requiresAuth && !loggedIn) next({ name: 'login' })
    else if (!requiresAuth && loggedIn && !is403) next({ name: user.Marketing ? 'marketing' : 'sales' })
    else if (!isAdmin) {
      if (to.name === 'marketing' && !user.Marketing) next({ name: 'sales' })
      else if (to.name === 'sales' && user.Marketing) next({ name: 'marketing' })
      else next()
    } else next()
  })
})
